module.exports = __webpack_public_path__ + "assets/img/7_344.70f2730e.jpg";